import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import api from "services/api";

import ReactDataSheet from "react-datasheet";
import "react-datasheet/lib/react-datasheet.css";

import moment from "config/Moment";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Creators as JourneysActions,
  Selectors as JourneysSelectors
} from "store/ducks/journeys";
import {
  Creators as InterviewsActions,
  Selectors as InterviewsSelectors
} from "store/ducks/interviews";

import { Validate } from "common";
import { Page, Panel, Button, Form, Loading } from "components";

import GridInitial from "./grid";

const SheetRenderer = props => {
  const {
    as: Tag,
    headerAs: Header,
    bodyAs: Body,
    rowAs: Row,
    cellAs: Cell,
    className,
    columns
  } = props;

  return (
    <Tag className={className} style={{ width: "100%" }}>
      <Header className="data-header">
        <Row>
          {columns.map(column => (
            <Cell
              className="cell"
              style={{ width: column.Width + "px" }}
              key={column.Name}
            >
              {column.Name}
            </Cell>
          ))}
        </Row>
      </Header>

      <Body className="data-body">{props.children}</Body>
    </Tag>
  );
};

class Batch extends Component {
  constructor(props) {
    super(props);

    this.sheetRenderer = this.sheetRenderer.bind(this);
    this.handleCellsChanged = this.handleCellsChanged.bind(this);

    const tableName = "Table::Participants";

    this.data = GridInitial;

    const grid = [
      ...this.data[tableName].map(row => {
        let rowData = [];
        let index = 0;

        for (let key in row) {
          rowData.push({
            value: row[key] || "",
            width: this.data.Columns[index].Width,
            Name: this.data.Columns[index].Name,
            readOnly: this.data.Columns[index].readOnly
          });

          ++index;
        }

        return rowData;
      })
    ];

    this.state = {
      as: "table",
      columns: this.data.Columns,
      grid: grid,
      selections: [false, false, false, false, false, false, false],
      data: {
        journey: ""
      },
      errors: {},

      results: {
        success: [],
        failure: []
      },
      done: false
    };
  }

  componentDidMount() {
    const { getInterviewableRequest } = this.props;
    getInterviewableRequest();
  }

  sheetRenderer = props => {
    const { columns, selections, as } = this.state;

    switch (as) {
      case "list":
        return (
          <SheetRenderer
            columns={columns}
            selections={selections}
            onSelectAllChanged={this.handleSelectAllChanged}
            as="segment"
            headerAs="div"
            bodyAs="ul"
            rowAs="div"
            cellAs="div"
            {...props}
          />
        );
      case "div":
        return (
          <SheetRenderer
            columns={columns}
            selections={selections}
            onSelectAllChanged={this.handleSelectAllChanged}
            as="div"
            headerAs="div"
            bodyAs="div"
            rowAs="div"
            cellAs="div"
            {...props}
          />
        );
      default:
        return (
          <SheetRenderer
            columns={columns}
            selections={selections}
            onSelectAllChanged={this.handleSelectAllChanged}
            as="table"
            headerAs="thead"
            bodyAs="tbody"
            rowAs="tr"
            cellAs="th"
            {...props}
          />
        );
    }
  };

  handleCellsChanged = (changes, additions) => {
    const grid = this.state.grid.map(row => [...row]);

    changes.forEach(({ cell, row, col, value }) => {
      grid[row][col] = { ...grid[row][col], value };
    });

    if (additions) {
      additions.forEach(({ cell, row, col, value }) => {
        if (!grid[row]) {
          let emptyData = [];

          for (let i = 0; i < this.state.columns.length; i++) {
            emptyData.push({
              value: ""
            });
          }

          grid[row] = emptyData;
        }

        if (grid[row][col]) {
          grid[row][col] = { ...grid[row][col], value };
        }
      });
    }

    this.setState({ grid });
    this.handleValidate();
  };

  handleChangeJourney = journey => {
    this.setState({ journey });
    this.handleValidate();
  };

  handleSave = async () => {
    const { grid, data } = this.state;

    if (!this.handleValidate()) return null;

    const locales = {
      pt: "pt-BR",
      en: "en",
      es: "es"
    };

    const interviews = grid.map(innerGrid => {
      console.log(innerGrid)

      return {
        name: innerGrid[1].value,
        email: innerGrid[2].value,
        course: innerGrid[3].value,
        course_class: innerGrid[4].value,
        calculated_at: moment(innerGrid[5].value, "DD/MM/YYYY HH:mm").format(
          "YYYY-MM-DD HH:mm"
        ),
        locale: locales[innerGrid[6].value] || "pt-BR",
        coach_email: innerGrid[7].value || null,
        blind_participant: innerGrid[8].value === 'sim' ? false : true,
      }
    });

    this.setState({ loading: true });

    const response = await api.post("search/interviews/bulk", {
      interviewable_type: data.journey.value.type,
      interviewable_id: data.journey.value.key,
      interviews: interviews.filter(interview => interview.name !== "")
    });

    const results = response.data;

    this.setState({
      results: { success: results.result_ok, failure: results.result_error },
      loading: false,
      done: true
    });
  };

  handleChangeJourney = journey => {
    const { data } = this.state;

    this.setState({ data: { ...data, journey } });
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      grid: {
        required: true
      },

      journey: {
        required: true
      }
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  render() {
    const { data, errors, grid, done, loading, results } = this.state;
    const { journeys } = this.props;

    return (
      <Page>
        {done ? (
          <Fragment>
            <div className="row align-items-center">
              <div className="col-6">
                <Page.Title>Importação em Massa</Page.Title>
              </div>

              <div className="col-6 text-right" />
            </div>

            {!!results.success.length && (
              <Panel>
                <Panel.Title>
                  {results.success.length} importações realizadas com sucesso!
                </Panel.Title>
              </Panel>
            )}

            {!!results.failure.length && (
              <Panel>
                <Panel.Title>
                  {results.failure.length} importações falharam!
                </Panel.Title>
                <table className="table table-stripped">
                  <thead>
                    <tr>
                      <th>Nome</th>
                      <th>Curso</th>
                      <th>Turma</th>
                    </tr>
                  </thead>

                  <tbody>
                    {results.failure.map(result => (
                      <tr key={result.id}>
                        <td>{result.name}</td>
                        <td>{result.course}</td>
                        <td>{result.course_class}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Panel>
            )}
          </Fragment>
        ) : (
          <Fragment>
            <div className="row align-items-center">
              <div className="col-6">
                <Page.Title>Importação em Massa</Page.Title>
              </div>

              <div className="col-6 text-right">
                <Button
                  type="success"
                  onClick={this.handleSave}
                  disabled={loading}
                >
                  {loading ? (
                    <Loading type="btn" size="small" text="Salvando..." />
                  ) : (
                    "Salvar"
                  )}
                </Button>

                <Link to="/admin/interviews" className="btn btn-danger m-l-10">
                  Cancelar
                </Link>
              </div>
            </div>

            <Panel>
              <Form>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Jornada</Form.Label>
                    <Form.Select
                      name="journey"
                      placeholder="Selecione a jornada"
                      options={journeys.data}
                      value={data.journey}
                      errors={errors.journey}
                      onChange={journey => this.handleChangeJourney(journey)}
                    />
                  </Form.Group>
                </div>
                <div className="col-12">
                  <Form.Group>
                    <Form.Label>Entrevistas</Form.Label>
                    <ReactDataSheet
                      data={grid}
                      sheetRenderer={this.sheetRenderer}
                      onCellsChanged={this.handleCellsChanged}
                      valueRenderer={cell => cell.value}
                    />
                  </Form.Group>
                </div>
              </Form>
            </Panel>
          </Fragment>
        )}
      </Page>
    );
  }
}

const mapState = state => ({
  journeys: {
    ...state.interviews.interviewable,
    data: InterviewsSelectors.interviewable(state.interviews.interviewable.data)
  }
});

const mapActions = dispatch =>
  bindActionCreators({ ...JourneysActions, ...InterviewsActions }, dispatch);

export default connect(mapState, mapActions)(Batch);



// WEBPACK FOOTER //
// ./src/pages/Admin/Interviews/Bulk/index.js